import React from 'react';
import { Button } from 'e100-react-components';
import useStyles from './styles';
import { useMyFleetOperations } from 'features/myFleet/hooks';
import { useFilterContext } from '../context';
import { useIntl } from 'react-intl';

export const ActionButtons = () => {
  const classes = useStyles();

  const { locationStatus, deviceType, resetFilter } = useFilterContext();
  const { setFilter, setActiveDisplay } = useMyFleetOperations();
  const { formatMessage } = useIntl();

  const onApplyFilter = () => {
    setFilter({
      locationStatus,
      deviceType,
    });
    setActiveDisplay('carsList');
  };

  return (
    <div className={classes.container}>
      <Button color="primary" onClick={onApplyFilter}>
        {formatMessage({ id: 'apply' })}
      </Button>
      <Button onClick={resetFilter}>{formatMessage({ id: 'reset' })}</Button>
    </div>
  );
};
